import React from "react";
import { useAuthMe } from "./useAuthMe";
import type { CloudflareApplication } from "../layouts/sidebar/types";
import { parseCloudflareApplicationsFromAuth } from "../layouts/sidebar/parseCloudflareApplications";

function readStoredCloudflareApplications(): unknown {
  try {
    const raw = localStorage.getItem("auth_user");
    if (!raw) return undefined;
    const u = JSON.parse(raw) as { cloudflare_applications?: unknown };
    return u.cloudflare_applications;
  } catch {
    return undefined;
  }
}

/**
 * Cloudflare sidebar/embed data from stored session profile.
 * While that request is in flight, falls back to `localStorage` from the last session
 * so embed routes still resolve on hard refresh.
 */
export function useMergedCloudflareApplications(): CloudflareApplication[] {
  const { data: authUser, isPending } = useAuthMe();
  return React.useMemo(() => {
    const fromServer = authUser?.cloudflare_applications;
    const stored = readStoredCloudflareApplications();
    const raw =
      fromServer !== undefined && fromServer !== null
        ? fromServer
        : isPending
          ? stored
          : (fromServer ?? stored);
    return parseCloudflareApplicationsFromAuth(raw);
  }, [authUser, isPending]);
}
